<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Asset Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let item of assetTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + item.name">
            <input type="checkbox" [id]="'checkbox-' + item.name"
              [checked]="isIn(draftAssetTypes, item.value!)"
              (change)="draftAssetTypes = toggleGuid(draftAssetTypes, item)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + item.name">{{ item.name }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Event Channel -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "EVENT_CHANNEL_TYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let channel of eventChannels">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + channel">
            <input type="checkbox" [id]="'checkbox-' + channel"
              [checked]="isIn(draftEventChannels, channel)"
              (change)="draftEventChannels = toggle(draftEventChannels, channel)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + channel">{{ channel.toUpperCase() | translate }}</label>
        </div>
      </div>
    </div>
  </div>

</app-filter-panel>
